import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { sendPOST, sendGET } from "../utils/comm";
import { promoCode2Pennies } from "../utils/validate";
import { loadStripe } from "@stripe/stripe-js";

/*
const stripePromise_old2 = loadStripe(
  "pk_test_51HH4tnCnm7ZLFYMtQlIYDKsj28dSykOfl4qynOGGjIoFSIW90ritt0D1Z7VRVRJ1KXA6BUsaQIJH5scrajbxOSaL00mpIWw595"
);
*/

const stripePromise = loadStripe(
  "pk_live_51HH4tnCnm7ZLFYMtrTZUOUbGfYcBRlpzxoQCnGLjvfGjxwvnFWQwcQeRm8NegvsH3LrKAm5AnpcTECOTLv9Hqa6m00Ko1L280w"
);

/*
const stripePromise_new = loadStripe(
  "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"
);
*/

async function charge(surveyResult) {
  const stripe = await stripePromise;
  console.log("charge: survey:", surveyResult);
  // Call your backend to create the Checkout Session
  let pennies = promoCode2Pennies(surveyResult.promos, surveyResult.promo);
  if (pennies == null) {
    // This should never happen; we should never get into this 'charge' path if
    // the promo code is not known.
    alert("Invalid promo code;  sorry");
    return;
  }

  console.log("Posting for credit card start...");
  sendPOST(`/create-checkout-session/${surveyResult.dateValue}`, {
    id: surveyResult.dateValue,
    pennies,
    origin: window.origin,
  })
    .then(async (session) => {
      // When the customer clicks on the button, redirect them to Checkout.
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        console.log("Credit error:", result);
        alert("Error:" + result.error?.message);
        // If `Checkout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`. Or try...
      }
    })
    .catch((err) => {
      console.log("fail  send:", err);
      alert("Failed sending post:", err);
    });
}

export default (props) => {
  let { dateValue } = useParams();
  const [surveyResult, setSurveyResult] = useState(null);
  useEffect(() => {
    const fetchResultFromServer = async () => {
      console.log("GetPayment: useEffect: Fetching result from server...");
      let localSurveyResult = await sendGET("/result/" + dateValue);
      setSurveyResult(localSurveyResult);
      charge(localSurveyResult);
    };

    fetchResultFromServer();
  }, [dateValue]);

  let style = { margin: "auto", width: "60%" };
  let outerStyle = {
    textAlign: "center",
    marginTop: "50px",
    fontSize: "1.5em",
    //fontWeight: "bold",
  };

  if (!surveyResult) return <div>Retrieving Invoice ID:{dateValue}</div>;
  return (
    <div style={outerStyle}>
      <div style={{ ...style, marginBottom: "1em" }}>
        Establishing payment information for <b>{surveyResult.userEmail}</b>
      </div>
      <CircularProgress size={80} thickness={6} />
    </div>
  );
};
